import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

/**
 * Reusable PasswordInput component with neutral/monochrome show-hide eye toggle.
 * Meets requirements: "parolni kura olw bulsn kuzca yorqin ranglardan qoc ... rangsiz"
 */
export default function PasswordInput({
  value,
  onChange,
  placeholder = 'Parol...',
  required = false,
  minLength,
  className = '',
  name,
  id,
  autoComplete = 'current-password',
  disabled = false,
  startIcon,
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative w-full">
      {startIcon && (
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400">
          {startIcon}
        </div>
      )}
      <input
        type={showPassword ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        minLength={minLength}
        name={name}
        id={id}
        autoComplete={autoComplete}
        disabled={disabled}
        className={`${className} ${startIcon ? 'pl-9' : ''} pr-10`}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShowPassword((prev) => !prev)}
        aria-label={showPassword ? "Parolni yashirish" : "Parolni ko'rsatish"}
        className="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-200 transition-colors cursor-pointer focus:outline-none"
      >
        {showPassword ? (
          <EyeOff className="w-4 h-4 text-slate-400 hover:text-slate-200 transition-colors" />
        ) : (
          <Eye className="w-4 h-4 text-slate-400 hover:text-slate-200 transition-colors" />
        )}
      </button>
    </div>
  );
}
